export const templateListSelector = (state) => state.referential_templates.list
export const templatePaginationSelector = (state) =>
  state.referential_templates.pagination
export const selectedTemplateSelector = (state) =>
  state.referential_templates.selected
export const templateSearchSelector = (state) =>
  state.referential_templates.search
export const templatePerPageSelector = (state) =>
  state.referential_templates.per_page
